import type { ShopperContextType } from '../contexts/shopper'

// Resolves the effective date used for SBC/brochure year selection: prefers the
// form's start date, falling back to the loaded quote's requestedEffectiveDate
// (e.g. when a quote is opened directly via a `quoteId` URL and the form was never filled out).
export const getEffectiveDateFromContext = (
  shopperContextValue?: ShopperContextType
): string | undefined =>
  shopperContextValue?.formData?.startDate ||
  shopperContextValue?.quoteData?.quoteApplication?.quotedPlan
    ?.requestedEffectiveDate

// startDate comes from the primary-subscriber-start-date dropdown; falls back to today when unset/invalid
export const getPlanYear = (startDate?: string): '2026' | '2027' => {
  // Parse plain "YYYY-MM-DD" as local calendar date; `new Date(str)` treats it as
  // UTC midnight, which rolls back a day (into 2026) in US timezones for 2027-01-01.
  const isoMatch = startDate?.match(/^(\d{4})-(\d{2})-(\d{2})$/)
  if (isoMatch) {
    const [, year] = isoMatch
    return Number(year) >= 2027 ? '2027' : '2026'
  }

  const parsed = startDate ? new Date(startDate) : new Date()
  const date = isNaN(parsed.getTime()) ? new Date() : parsed
  return date.getFullYear() >= 2027 ? '2027' : '2026'
}
